export default __webpack_public_path__ + "static/media/Brand.e7bc0a7b.svg";